/*

  Usage Gide
  ---------------------------------------------------------

• HTML 

  <div class="header">
    <p id="headerText"></p>
  </div>
  
  <div id="calendar"></div>
  


• JavaScript

  const calendar = new MiniCalendar(document.querySelector('#calendar'));
  OR 
  calendar.setCalenderContainer(document.querySelector('#calendar'));

  calendar.setHeaderTextElement(document.querySelector("#headerText"));

  // Methods
  calendar.nextMonth();
  calendar.prevMonth();
  calendar.goToToday();

*/


class MiniCalendar {
  static TODAY = new Date();
  static DAYS = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  static EVENT_STRING = "|%|";

  // Private Variables
  #today = {};
  #curr_month = { numeric: 0, text: "January" };

  #header_text = {};

  #grid = {}; // Info used to show on grid on current month
  #grid_container = null;



  #monthEvents = {};

  constructor(el) { 
    this.#setDates();
    if (el) {
      this.#setContainer(el);
      this.#renderGrid();
      this.#addEventListeners();
     
    }
  }

  #setDates() {
    const date = new Date();
    this.#today = {
      day: date.toLocaleString("default", { weekday: "long" }),
      date: date.toLocaleString("default", { day: "numeric" }),
      month: date.toLocaleString("default", { month: "long" }),
      year: date.toLocaleString("default", { year: "numeric" }),
    };
    this.#curr_month = {
      numeric: date.getMonth(),
      text: this.#today.month,
    };
  }

  #setHeaderTextEl(el) {
    this.#header_text = el;
  }

  #setContainer(el) {
    this.#grid_container = el;
  }

  #renderGrid() {
    // create a grid of days for the current month
    const daysInMonth = new Date(
      this.#today.year,
      this.#curr_month.numeric + 1,
      0
    ).getDate();

    const firstDayOfMonth = new Date(
      this.#today.year,
      this.#curr_month.numeric,
      1
    ).toLocaleString("default", { weekday: "long" });

    const lastDayOfMonth = new Date(
      this.#today.year,
      this.#curr_month.numeric,
      daysInMonth
    ).toLocaleString("default", { weekday: "long" });

    const grid = {
      daysInMonth,
      firstDayOfMonth,
      lastDayOfMonth,
      rows: [],
    };

    let row = [];
    const currMonth = this.#today.month;
    let dayOfWeek = this.#getDayOfWeek(firstDayOfMonth);

    // create array of weeks
    for (let i = 1; i <= daysInMonth; i++) {
      const dayData = { day: i, data: this.#monthEvents[i] };

      row.push(dayData);

      if (dayOfWeek === 6 || i === daysInMonth) {
        grid.rows.push(row);
        row = [];
      }

      dayOfWeek = (dayOfWeek + 1) % 7;
    }

    this.#grid = grid;
    this.#grid_container.innerHTML = "";
    this.#updateGrid();
  }

  #getDayOfWeek(day) {
    return MiniCalendar.DAYS.indexOf(day);
  }

  #updateGrid() {
    if (!this.#grid_container) return;

    let grid = this.#grid_container.querySelector(".grid");

    if (!grid) {
      grid = document.createElement("table");
      grid.classList.add("grid");
      this.#grid_container.appendChild(grid);
    }

    grid.innerHTML = "";

    // render the grid header
    const thead = document.createElement("thead");
    const tr = document.createElement("tr");

    for (let i = 0; i < 7; i++) {
      const th = document.createElement("th");
      th.textContent = MiniCalendar.DAYS[i].slice(0, 3);
      tr.appendChild(th);
    }

    thead.appendChild(tr);
    grid.appendChild(thead);

    // render the grid body
    const tbody = document.createElement("tbody");
    // console.log("tbody");
    // console.log(tbody);
    // console.log("tbody");

  
    for (let i = 0; i < this.#grid.rows.length; i++) {
      const tr = document.createElement("tr");
      const row = this.#grid.rows[i];

      // first row empty cells
      if (row.length < 7 && i < this.#grid.rows.length - 1) {
        this.#addEmptyCells(row, tr);
      }

      // Month cells
      for (let j = 0; j < row.length; j++) {
        const dayData = row[j];
       
        const td = document.createElement("td");
        td.textContent = dayData.day;

        if (dayData.data) {
          td.setAttribute(
            "data-info",
            dayData.data.join(MiniCalendar.EVENT_STRING)
          );
        }

        if (
          this.#today.date == dayData.day &&
          this.#today.month ===
            new Date().toLocaleString("default", { month: "long" })
        ) {
          td.setAttribute("data-today", "");
        }

        tr.appendChild(td);
      }

      // last row empty cells
      if (row.length < 7 && i === this.#grid.rows.length - 1) {
        this.#addEmptyCells(row, tr);
      }

      tbody.appendChild(tr);
    }

    this.#header_text.innerHTML = this.headText;
    grid.appendChild(tbody);
    this.#addEventListeners();
  }

  #addEmptyCells(row, tr) {
    for (let j = 0; j < 7 - row.length; j++) {
      const td = document.createElement("td");
      td.textContent = "";
      td.classList.add("empty");
      tr.appendChild(td);
    }
  }

  #addEventListeners() {
    if (!this.#grid_container) return;

    const grid = this.#grid_container.querySelector(".grid");

    if (!grid) return;

    grid.addEventListener("mouseover", (event) => {
      const td = event.target.closest("td");
      if (!td) return;

      const info = td.getAttribute("data-info");
      if (!info) return;

      const tooltopExists = td.querySelector(".cal-tooltip");
      if (tooltopExists) return;

      const tooltip = document.createElement("div");

      const events = info.split(MiniCalendar.EVENT_STRING);
      for (const event of events) {
        if (event) {
          const ev = document.createElement("div");
          ev.textContent = event;
          ev.classList.add("event");
          tooltip.append(ev);
        }
      }

      tooltip.classList.add("cal-tooltip", "events-container");
      td.appendChild(tooltip);
    });

    grid.addEventListener("mouseout", (event) => {
      const td = event.target.closest("td");
      if (!td) return;

      const tooltip = td.querySelector(".cal-tooltip");
      if (tooltip) td.removeChild(tooltip);
    });

    // grid.querySelectorAll("td[data-info]").forEach((td) => {
    grid.querySelectorAll("td").forEach((td) => {
      td?.addEventListener("click", (event) => {
       // console.log(event.target.firstChild)
      //  console.log(event.target.firstChild)
      //  console.log(this.#today.month)
      //  console.log(this.#today.year)
      var months = ['','January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    
     const Month_index = months.indexOf(this.#today.month);
     const Select_date = this.#today.year+'-'+Month_index+'-'+event.target.firstChild.data;
     //console.log(Month_index);
        this.onDateClick(event);
        this.onEventTextInMonthClick(Select_date);
        this.getDayWishBirthday(Select_date)
      });
    });
  }

  setHeaderTextElement(el) {
    this.#setHeaderTextEl(el);
    this.#renderGrid();
  }

  setCalenderContainer(el) {
    this.#setContainer(el);
    this.#renderGrid();
  }

  /**
   * Switch calender to next month
   */
  #next() {
    this.#curr_month.numeric++;
    var months = ['','January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const Month_index = months.indexOf(this.#today.month);
    //alert(this.#curr_month.numeric)
    this.onEventInMonthClick(Month_index+1);
    if (this.#curr_month.numeric > 11) {
      this.#curr_month.numeric = 0;
      this.#today.year++;
    }

    this.#today.month = new Date(
      this.#today.year,
      this.#curr_month.numeric
    ).toLocaleString("default", { month: "long" });

    this.#renderGrid();
  }

  /**
   * Switch calender to previous month
   */
  #prev() {
    this.#curr_month.numeric--;
    var months = ['','January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const Month_index = months.indexOf(this.#today.month);
    this.onEventInMonthClick(this.#curr_month.numeric+1);
    if (this.#curr_month.numeric < 0) {
      this.#curr_month.numeric = 11;
      this.#today.year--;
    }

    this.#today.month = new Date(
      this.#today.year,
      this.#curr_month.numeric
    ).toLocaleString("default", { month: "long" });

    this.#renderGrid();
  }

  /**
   * Over-writes the default "monthEvents" object value to the object in the argument
   * @param {{}} eventsObj
   * @example
   * const eventsObj = {
   *  3: ["Event 1", "Event 2"],
   *  9: ["Event 1", "Event 2"],
   *  ... };
   *
   * setEventsTo(eventsObj);
   */
  #setThisMonthEventsTo(eventsObj) {
    //// console.log('eventsObj'+eventsObj.s)
    if (!eventsObj) throw Error("Months' event object is inValid");
   // if(eventsObj){ this.#monthEvents = eventsObj;}
    this.#monthEvents = eventsObj;
    this.#renderGrid();
  }

  /**
   * Switch calender to current month
   */
  #goToToday = function () {
    this.#setDates();
    this.#renderGrid();
  };

  get next() {
    return this.#next;
  }

  get prev() {
    return this.#prev;
  }

  get goToToday() {
    return this.#goToToday;
  }

  get headText() {
    return this.#today.month.slice(0, 3) + " " + this.#today.year;
  }

  get setEvents() {
    return this.#setThisMonthEventsTo;
  }

  onHover = function (event) {
    return null;
  };

  onDateClick = function (event) {
    return null;
  };
  onEventInMonthClick = async function  (event) {
   // alert(event)
    let SERVER_URL = process.env.REACT_APP_API_URL;
	  let token = JSON.parse(localStorage.getItem('key'));
    const response1 = await fetch(SERVER_URL + `api/holiday/office-holiday-in-month-list`, {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json',
        'Content-Type': 'application/json',
        'authorization': `bearer ${token.value}`
        // Add any other headers if needed
      },
      body: JSON.stringify({
                  month_no: event,
                  year:this.#today.year
              }),
    });
    if (!response1.ok) {
      throw new Error('Failed to fetch data');
    }

    const data = await response1.json();
   
    const merge_tempData = []
    const merge_tempData2 = []
    let myObject = {}
    if(data.officeHoliday.length > 0){
      for (let i = 0; i < data.officeHoliday.length; i++) {
        let indexArr = data.officeHoliday[i].day;
        let textArr = data.officeHoliday[i].level;
          merge_tempData.push(indexArr)
          merge_tempData2.push(textArr)
         // console.log(merge_tempData)
          if(merge_tempData[0] == 1 && merge_tempData[1] == 26){
            this.#setThisMonthEventsTo({1:['New Years Day'],26:['Republic Day']});
          }else if(merge_tempData[0] == 25 && merge_tempData[1] == 29){
            this.#setThisMonthEventsTo({25:['Holi'],29:['Good Friday']});
          }else if(merge_tempData[0] == 11 ){
            this.#setThisMonthEventsTo({11:['Eid-ul-Fitar']});
          }else if(merge_tempData[0] == 15 && merge_tempData[1] == 26 ){
            this.#setThisMonthEventsTo({15:['Independence Day'],26:['Janmashtam']});
          }else if(merge_tempData[0] == 2 && merge_tempData[1] == 31 ){
            this.#setThisMonthEventsTo({2:['Gandhi Jayanti'],31:['Diwali']});
          }else if(merge_tempData[0] == 25 ){
            this.#setThisMonthEventsTo({25:['Christmas']});
          }
           
      }
    }else{
      this.#setThisMonthEventsTo({});
    }
   
 
  };
  getDayWishBirthday = function (SelectedDate){
   
  //  console.log('SelectedDate_'+SelectedDate)

    return SelectedDate;
    
  }
  onEventTextInMonthClick = function (SelectedDate){
   
    //  console.log('SelectedDate_'+SelectedDate)
  
      return SelectedDate;
      
    }
}


export default MiniCalendar;
